// 5 x 5 Heat Map

import { CHIP_VERY_HIGH, CHIP_VERY_LOW } from './IssueTypes'

export const RISK_SCORE_ONE = 1
export const RISK_SCORE_TWO = 2
export const RISK_SCORE_THREE = 3
export const RISK_SCORE_FOUR = 4
export const RISK_SCORE_FIVE = 5
export const RISK_SCORE_SIX = 6
export const RISK_SCORE_EIGHT = 8
export const RISK_SCORE_NINE = 9
export const RISK_SCORE_TEN = 10
export const RISK_SCORE_TWELVE = 12
export const RISK_SCORE_FIFTEEN = 15
export const RISK_SCORE_SIXTEEN = 16
export const RISK_SCORE_TWENTY = 20
export const RISK_SCORE_TWENTY_FIVE = 25

export const MITIGATION = 19

export const RISK_RATINNG = [
    { title: 'Controlled', color: 'hsl(var(--Controlled))' },
    { title: 'Low', color: 'hsl(var(--Low))' },
    { title: 'Medium', color: 'hsl(var(--Medium))' },
    { title: 'High', color: 'hsl(var(--High))' },
    { title: 'Extreme', color: 'hsl(var(--Extreme))' }
]

export const RISK_LEVEL_CONTROLLED = 'Controlled'
export const RISK_LEVEL_LOW = 'Low'
export const RISK_LEVEL_MEDIUM = 'Medium'
export const RISK_LEVEL_HIGH = 'High'
export const RISK_LEVEL_EXTREME = 'Extreme'

export const RISK_SCROING_DATA = [
    [{ value: 5, color: 'hsl(var(--Low))' }, { value: 10, color: 'hsl(var(--High))' }, { value: 15, color: 'hsl(var(--High))' }, { value: 20, color: 'hsl(var(--Extreme))' }, { value: 25, color: 'hsl(var(--Extreme))' }],
    [{ value: 4, color: 'hsl(var(--Low))' }, { value: 8, color: 'hsl(var(--Medium))' }, { value: 12, color: 'hsl(var(--High))' }, { value: 16, color: 'hsl(var(--High))' }, { value: 20, color: 'hsl(var(--Extreme))' }],
    [{ value: 3, color: 'hsl(var(--Low))' }, { value: 6, color: 'hsl(var(--Low))' }, { value: 9, color: 'hsl(var(--Medium))' }, { value: 12, color: 'hsl(var(--High))' }, { value: 15, color: 'hsl(var(--High))' }],
    [{ value: 2, color: 'hsl(var(--Controlled))' }, { value: 4, color: 'hsl(var(--Low))' }, { value: 6, color: 'hsl(var(--Low))' }, { value: 8, color: 'hsl(var(--Medium))' }, { value: 10, color: 'hsl(var(--High))' }],
    [{ value: 1, color: 'hsl(var(--Controlled))' }, { value: 2, color: 'hsl(var(--Controlled))' }, { value: 3, color: 'hsl(var(--Low))' }, { value: 4, color: 'hsl(var(--Low))' }, { value: 5, color: 'hsl(var(--Low))' }]
]

export const IMPACT_VALUE = [ 5, 4, 3, 2, 1 ]
export const PROBABILITY_VALUE = [ 1, 2, 3, 4, 5 ]

export const xLabels = [ 'Unlikely', 'Remote', 'Occasional', 'Certain', 'Frequent' ]
export const yLabels = [ 'Catastrophic', 'Major', 'Serious', 'Marginal', 'Negligible' ]

export const SELECT_OPTIONS = [
    { label: 'Apple', value: 'apple' },
    { label: 'Banana', value: 'banana' },
    { label: 'Blueberry', value: 'blueberry' },
    { label: 'Grapes', value: 'grapes' },
    { label: 'Pineapple', value: 'pineapple' }
]

// 3 x 3 Heat Map

export const IMPACT_VALUE_THREE_CROSS = [ 3, 2, 1 ]
export const PROBABILITY_VALUE_THREE_CROSS = [ 1, 2, 3 ]

export const Y_LABLES_THREE_CROSS = [ 'Catastrophic', 'Serious', 'Negligible' ]
export const X_LABLES_THREE_CROSS = [ 'Unlikely', 'Occasional', 'Frequent' ]

export const RISK_RATINNG_THREE_CROSS = [
    { title: 'Low', color: 'hsl(var(--Low))' },
    { title: 'Medium', color: 'hsl(var(--Medium))' },
    { title: 'Extreme', color: 'hsl(var(--Extreme))' }
]

export const RISK_SCROING_DATA_THREE_CROSS = [
    [{ value: 3, color: 'hsl(var(--Medium))' }, { value: 6, color: 'hsl(var(--Extreme))' }, { value: 9, color: 'hsl(var(--Extreme))' }],
    [{ value: 2, color: 'hsl(var(--Low))' }, { value: 4, color: 'hsl(var(--Medium))' }, { value: 6, color: 'hsl(var(--Extreme))' }],
    [{ value: 1, color: 'hsl(var(--Low))' }, { value: 2, color: 'hsl(var(--Low))' }, { value: 3, color: 'hsl(var(--Medium))' }]
]

// risk card types
export const INITIATION = 'Initiation'
export const ANALYZE = 'Analyze'
export const MITIGATION_PLAN = 'MitigationPlan'
export const MONITORING = 'Monitoring'
export const APPROVAL = 'Approval'
export const RAISED = 1
export const OWNED = 2
export const ALL = 3
export const ANALYZE_AND_MITIGATION = 'Analyze & Mitigation'
export const CHIP_EXTREME = 'Extreme'
export const CHIP_HIGH = 'High'
export const CHIP_MEDIUM = 'Medium'
export const CHIP_LOW = 'Low'
export const CHIP_CONTROLLED = 'Controlled'
export const EXTERNAL = 'External'

// mitigation

export const DISPUTE_TABLE_HEADERS = [

    {
        field: 'risk',
        headerName: 'Risk',
        width: 150,
        editable: false
    },
    {
        field: 'description',
        headerName: 'Description',
        editable: false
    },
    {
        field: 'suggestedMitigation',
        headerName: 'Suggested Mitigation',
        width: 150,
        editable: false
    },
    {
        field: 'status',
        headerName: 'Status',
        editable: false
    },
    // {
    //     field: 'approach',
    //     headerName: 'Approach',
    //     editable: false
    // },
    {
        field: 'aging',
        headerName: 'Age',
        width: 150,
        editable: false
    },
    {
        field: 'type',
        headerName: 'Type',
        width: 150,
        editable: false
    },
    {
        field: 'riskNature',
        headerName: 'Risk Nature',
        width: 150,
        editable: false
    },
    {
        field: 'category',
        headerName: 'Category',
        width: 150,
        editable: false
    },
    {
        field: 'riskOwner',
        headerName: 'Risk Owner',
        width: 150
    },
    {
        field: 'impactedDepartment',
        headerName: 'Impacted Dept',
        width: 250
    },
    {
        field: 'raisedDepartment',
        headerName: 'Raised Dept',
        width: 150
    },
    {
        field: 'raisedBy',
        headerName: 'Raised By',
        width: 150,
        editable: false
    },
    {
        field: 'createdDate',
        headerName: 'Created Date',
        width: 150
    },
    {
        field: 'periodicity',
        headerName: 'Periodicity',
        width: 150
    },
    {
        field: '',
        headerName: '',
        width: 50,
        description: 'This column has a value getter and is not sortable.',
        sortable: false
    }
]

export const DOT = 'dot'

export const MEASURES = 'Measures'
export const IDENTIFIED_ON = 'IdentifiedOn'
export const RESOLUTION_DATE = 'resolutionDate'
export const DEPARTMENT = 'Department'
export const END_DATE = 'EndDate'
export const START_DATE = 'StartDate'

export const KISS_METHOD_ID = 0
export const HEAT_MAP_ID = 1

export const RISK_INFO_STATUS = 'riskInfo'
export const ASSESSMENT_STATUS = 'assessment'
export const MITIGATION_STATUS = 'mitigation'
export const MONITORING_STATUS = 'monitoring'

export const RISK_INFO_STATUS_NUM = 17
export const ASSESSMENT_STATUS_NUM = 18
export const MITIGATION_STATUS_NUM = 19
export const MONITORING_STATUS_NUM = 21

export const MITITGATION_APPROACH = [
    { label: 'Acceptance', value: 1 },
    { label: 'Avoidance', value: 2 },
    { label: 'Reduction', value: 3 },
    { label: 'Transfer', value: 4 }
]
export const ACCEPTANCE_ID = 1
export const AVOIDANCE_ID = 2
export const REDUCTION_ID = 3
export const TRANSFER_ID = 4
export const ACCEPTANCE = 'Acceptance'
export const AVOIDANCE = 'Avoidance'
export const REDUCTION = 'Reduction'
export const TRANSFER = 'Transfer'

export const TASK_COMPLETED_STATUS = 9
export const TASK_INPROGRESS_STATUS = 5

export const TASK_REJECTED_STATUS = 11
export const TASK_HARD_REJECTED_STATUS = 2
export const TASK_INITIAL = 5

export const RISK_INFORMATION_STATUS_ID = 8
export const ANALYZE_STATUS_ID = 3
export const FILTER_SHOW_HIDE = 'Show/Hide All'
export const FILTER_RESET = 'reset'

export const RISK_ACTION_HEADER = [

    {
        field: 'risk',
        headerName: 'Risk',
        width: 150,
        editable: false
    },
    {
        field: 'riskOwner',
        headerName: 'Owned Dept',
        width: 150,
        editable: false
    },
    {
        field: 'raisedDepartment',
        headerName: 'Raised Dept',
        width: 150,
        editable: false
    },
    {
        field: 'aging',
        headerName: 'Age',
        width: 50,
        editable: false
    },
    {
        field: 'status',
        headerName: 'Status',
        editable: false
    }
]
// risk history filter keys
export const FILTER_STATUS = 'status'
export const FILTER_RISK_LEVEL = 'riskLevel'
export const FILTER_SOURCE_OF_RISK = 'sourceOfRisk'
export const FILTER_TYPE = 'types'
export const FILTER_CATEGORY = 'category'
export const FILTER_APPROACH = 'approach'
export const FILTER_RISK_OWNER = 'riskOwner'
export const FILTER_IMPACTED_DEPARTMENT = 'impactedDepartment'
export const FILTER_IDENTIFIED_ON = 'identifiedOn'
export const RISK_DISABLED_COLUMN_SETTINGS = [ 'Risk', 'Description', 'Status', 'Aging', 'Type', 'Risk Nature', 'Category', 'Risk Owner', 'Impacted Dept', 'Suggested Mitigation' ]

export const chipColorStyle = riskScoreValue => {
    let textColor = 'hsl(var(--foreground))'
    if (riskScoreValue === CHIP_CONTROLLED || riskScoreValue === CHIP_VERY_LOW) {
        textColor = 'hsl(var(--Controlled))'
    } else if (riskScoreValue === CHIP_LOW) {
        textColor = 'hsl(var(--Low))'
    } else if (riskScoreValue === CHIP_MEDIUM) {
        textColor = 'hsl(var(--Medium))'
    } else if (riskScoreValue === CHIP_HIGH) {
        textColor = 'hsl(var(--High))'
    } else if (riskScoreValue === CHIP_EXTREME || riskScoreValue === CHIP_VERY_HIGH) {
        textColor = 'hsl(var(--Extreme))'
    }
    return textColor
}
